import React from "react";
import { Link } from "react-router-dom";
import "./Product.css";
import PageHeader from "../../components/headers/PageHeader";
import wave from "../../assets/Images/waves/mix_wave.jpg";

export default function Product() {
    return (
        <div className="product-page">
            <PageHeader
                mediaSrc={wave}
                mediaType="image"
                subtitle="Technology Solutions"
                title="Products"
            />

            <section className="product-section product-introSection">
                <h2>
                    Bespoke technology platforms tailored to fit evolving research
                    and regulatory needs
                </h2>

                <p>
                    Eupraxia’s product ecosystem brings together automation,
                    analytics, and intelligent oversight through purpose-built
                    platforms tailored to fit the needs of sponsors, CROs,
                    laboratories, and clinical development teams. Our solutions are
                    designed to improve execution quality, reduce operational
                    complexity, and support faster, more structured decision-making
                    across regulated research environments.
                </p>
            </section>

            <section className="product-section product-detailSection">
                <h2>Aletheion™</h2>

                <p className="product-tagline">
                    SEND automation for preclinical regulatory data operations.
                </p>

                <p className="product-description">
                    Aletheion™ is a preclinical SEND automation platform designed
                    to support structured nonclinical study data processing, SEND
                    dataset generation, domain-level review, validation workflows,
                    and submission-ready package preparation.
                </p>

                <ul className="product-highlightList">
                    <li>Built specifically for SEND and preclinical data automation</li>
                    <li>Supports structured nonclinical domain processing</li>
                    <li>Helps streamline dataset generation and review workflows</li>
                    <li>Designed for scalable regulatory data operations</li>
                </ul>

                <Link to="/products/aletheion" className="product-link">
                    Explore Aletheion™
                </Link>
            </section>

            <section className="product-section product-detailSection">
                <h2>Nebula™</h2>

                <p className="product-tagline">
                    AI-enabled RBQM and clinical trial oversight platform.
                </p>

                <p className="product-description">
                    Nebula™ supports risk-based quality management by helping
                    clinical operations teams identify risks, monitor key
                    indicators, track site performance, and move from reactive
                    trial management to proactive execution control.
                </p>

                <ul className="product-highlightList">
                    <li>Risk-Based Quality Management support</li>
                    <li>KRI tracking and centralized monitoring</li>
                    <li>Site performance and operational risk insights</li>
                    <li>AI-assisted trial oversight and issue escalation</li>
                </ul>

                <Link to="/products/nebula" className="product-link">
                    Explore Nebula™
                </Link>
            </section>

            <section className="product-section product-detailSection">
                <h2>Pronoia Patient Intelligence™</h2>

                <p className="product-tagline">
                    Patient cohort intelligence and population feasibility analytics.
                </p>

                <p className="product-description">
                    Pronoia Patient Intelligence™ helps sponsors and clinical
                    development teams understand where the right patients are, which
                    sites may have access to those patients, and how protocol
                    inclusion and exclusion criteria may affect the available study
                    population.
                </p>

                <ul className="product-highlightList">
                    <li>Patient cohort counts and feasibility analysis</li>
                    <li>Age, sex, race, region, and population breakdowns</li>
                    <li>Diagnosis, comorbidity, and treatment history patterns</li>
                    <li>Site and patient density insights for regional planning</li>
                    <li>Inclusion and exclusion criteria impact simulation</li>
                    <li>CSV, Excel, claims, lab, medication, and site history data support</li>
                </ul>

                <Link to="/products/pronoia-patient-intelligence" className="product-link">
                    Explore Pronoia Patient Intelligence™
                </Link>
            </section>
        </div>
    );
}